import { z } from "zod";

export const characterSchema = z.object({
  name: z
    .string()
    .min(3, { message: "Name must be at least 3 characters long" }),
});

export type CharacterSchema = z.infer<typeof characterSchema>;
